import React, { useEffect, useMemo, useState } from 'react'
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat.jsx'
import Select from 'react-select'
import FacilityCRUD from '../../services/general/getFacilityData.api.js'
import SavePatients from '../../services/general/savePatientinformation.api.js'
import fetchPatientData from '../../services/general/patientGeneralAPI.api.js'
import PatientAppointmentDetails from '../../services/general/appointmentData.api.js'
import { CFormLabel, CTable, CTableBody, CTableDataCell, CTableHead, CTableHeaderCell, CTableRow, CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import Pageloader from '../../components/shared/Pageloader.jsx'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api.js'
import Topper from '../../components/shared/Topper.jsx'
const ProviderAnalytics = () => {
  const [allFacility, setAllFacility] = useState([])
  const [filterData, setFilterData] = useState({
    facility: [],
    providers: [],
    date: '',
  })
  const [loggedUserProvider, setLoggedUserProvider] = useState({})

  useEffect(() => {
    const today = new Date()
    const mm = String(today.getMonth() + 1).padStart(2, '0') // months are 0-based
    const dd = String(today.getDate()).padStart(2, '0')
    const yyyy = today.getFullYear()

    const formattedDate = `${mm}/${dd}/${yyyy}`

    setFilterData((prev) => ({
      ...prev,
      date: formattedDate,
    }))
  }, [])

  const [statsValue, setStatsValue] = useState({
    totalAppointments: 0,
    totalFinishedAppointments: 0,
    totalSignedAppointments: 0,
    totalNotSignedAppointments: 0,
    totalLeftAppointments: 0,
    totalNotSeenAppointments: 0,
  })
  const [facilities, setFacilities] = useState([])
  const [patientData, setPatientData] = useState('')
  const [providerList, setProviderList] = useState([])
  const [appointments, setAppointments] = useState([])
  const [allAppointment, setAllAppointment] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(false)

  const patientDataFn = async () => {
    try {
      let patientData = await SavePatients('GetAll', '', '', '')
      setPatientData(JSON.parse(patientData.d).Data)
    } catch (error) {
    } finally {
    }
  }

  useEffect(() => {
    patientDataFn()
  }, [])

  const getFacilities = async () => {
    let a = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(a.d)?.Data
    try {
      const formattedData = data.map((facility) => ({
        value: facility.ID,
        label: facility.Name,
      }))
      setFacilities(formattedData)
      setSelectedFacility(formattedData[0])
    } catch (e) {}
  }

  useEffect(() => {
    getFacilities()
  }, [])

  const getAppointmentData = async () => {
    setIsPageLoading(true)
    try {
      const result = await PatientAppointmentDetails('GET', '', '', '', '')

      // const result = await SaveExtra('Get_By_Type', 'multiAppointmentsData', '', '');
      const rawData = JSON.parse(result.d)?.Data || []

      let structuredData = []

      rawData.forEach((item) => {
        let parsedList = JSON.parse(item?.AppointmentDetails)

        if (Array.isArray(parsedList)) {
          parsedList.forEach((parsedItem) => {
            const patientID = parsedItem?.patientID
            const appointmentDetails = parsedItem?.appointmentDetails || []

            const formattedAppointments = appointmentDetails.map((appointment) => {
              const data = appointment?.data || {}
              const current = appointment?.current || {
                Patient: { value: data?.PatientID || '', label: data?.AppointmentName || 'Unknown' },
                Provider: { value: '', label: data?.ProviderName || 'Unknown' },
                Facility: { value: '', label: data?.Facility || 'Unknown' },
                Insurance: data?.Insurance || {},
                otherDetails: data?.otherDetails || {},
              }

              return { data, current }
            })

            structuredData.push({
              patientID,
              appointmentDetails: formattedAppointments,
            })
          })
        } else {
        }
      })

      setAllAppointment(structuredData)

      let flatAppointments = structuredData.flatMap((p) => p.appointmentDetails)
      const uniquePatientIDs = [...new Set(flatAppointments.map((item) => item.data.PatientID))]

      let updatedPatients = []
      if (uniquePatientIDs.length > 0) {
        try {
          updatedPatients = await Promise.all(
            uniquePatientIDs.map(async (patientId) => {
              try {
                const dataResponse = await PatientNoteDataCRUD('GET', patientId)
                const parsedData = JSON.parse(dataResponse?.d)?.Data || []

                return {
                  patientId,
                  allNotes: parsedData,
                }
              } catch (err) {
                return {
                  patientId,
                  allNotes: [],
                }
              }
            }),
          )
        } catch (err) {}
      }

      const appointmentsWithNotesStatusSigned = flatAppointments.map((appointment) => {
        const patientNotes = updatedPatients.find((p) => p.patientId === appointment.data.PatientID)

        const matchingNote = patientNotes?.allNotes?.find((note) => note.id === appointment.data.NoteID)

        return {
          ...appointment,
          data: {
            ...appointment.data,
            hasSignedNote: (matchingNote?.status?.toLowerCase() === 'signed' && matchingNote?.flag === 'true') || false,
            noteMatch: matchingNote
              ? {
                  id: matchingNote.id,
                  status: matchingNote.status,
                  flag: matchingNote.flag,
                }
              : null,
          },
        }
      })

      setAppointments(appointmentsWithNotesStatusSigned)

      return flatAppointments
    } catch (error) {
    } finally {
      setIsPageLoading(false)
    }
  }

  useEffect(() => {
    getAppointmentData()
  }, [])

  const getProviders = async () => {
    try {
      // Fetch provider data
      let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
      providerData = JSON.parse(providerData.d)?.Data
      setProviderList(providerData)
      const getUser = JSON.parse(localStorage.getItem('user'))
      const foundProvider = providerData.find((obj) => obj.UserId === getUser?.Username)
      setLoggedUserProvider(foundProvider || {})
    } catch (error) {
    } finally {
    }
  }

  const providerOptions = providerList.map((provider) => ({
    value: provider.ID,
    label: `${provider.Name}`, // what shows in dropdown
  }))

  useEffect(() => {
    getProviders()
  }, [])

  const [facilityGroupedStats, setFacilityGroupedStats] = useState([])

  useEffect(() => {
    const filterAppointments = appointments.filter((appt) => {
      const forThisProvider = loggedUserProvider?.Name && appt.data.ProviderName === loggedUserProvider?.Name

      const facilityMatch = filterData.facility.length === 0 || filterData.facility.includes(appt.data.Facility)

      const providerMatch = filterData.providers.length === 0 || filterData.providers.includes(appt.data.ProviderName)

      const dateMatch = !filterData.date || new Date(appt.data.StartTime).toDateString() === new Date(filterData.date).toDateString()

      return facilityMatch && providerMatch && dateMatch && forThisProvider
    })

    const totalAppointments = filterAppointments.length

    const totalFinishedAppointments = filterAppointments.filter((appt) => ['finish', 'finished'].includes(appt.data.Status?.toLowerCase())).length

    const totalNotSeenAppointments = filterAppointments.filter((appt) => appt.data.patientSeen === false).length
    const totalSignedAppointments = filterAppointments.filter((appt) => appt.data.hasSignedNote && appt.data.patientSeen !== false).length
    const totalNotSignedAppointments = filterAppointments.filter((appt) => !appt.data.hasSignedNote && appt.data.patientSeen !== false).length

    const totalLeftAppointments = filterAppointments.filter((appt) => ['scheduled', 'rescheduled', 'canceled', 'Draft'].includes(appt.data.Status?.toLowerCase()) && appt.data.patientSeen !== false).length

    setStatsValue((prev) => ({
      ...prev,
      totalAppointments,
      totalLeftAppointments,
      totalNotSeenAppointments,
      totalFinishedAppointments,
      totalSignedAppointments,
      totalNotSignedAppointments,
    }))
  }, [filterData, appointments, providerList, loggedUserProvider])

  const [filterDataFacility, setFilterDataFacility] = useState({
    facility: [],
    date: '',
    dateFrom: '',
    dateTo: '',
    search: '',
  })

  useEffect(() => {
    setIsPageLoading(true)

    let filteredFacilities = facilities

    if (filterDataFacility.facility.length > 0) {
      filteredFacilities = facilities.filter((fac) => filterDataFacility.facility.includes(fac?.label))
    }
    if (filterDataFacility.search) {
      const searchTerm = filterDataFacility.search.toLowerCase()
      filteredFacilities = filteredFacilities.filter((fac) => fac?.label.toLowerCase().includes(searchTerm))
    }

    const mapFacilityStats = filteredFacilities.map((fac) => {
      let facilityAppointments = appointments.filter((appt) => appt.data.Facility === fac?.label && appt?.data?.ProviderName === loggedUserProvider?.Name)

      if (filterDataFacility.dateFrom || filterDataFacility.dateTo) {
        facilityAppointments = facilityAppointments.filter((appt) => {
          const apptDate = new Date(appt.data.StartTime)
          const from = filterDataFacility.dateFrom ? new Date(filterDataFacility.dateFrom) : null
          const to = filterDataFacility.dateTo ? new Date(filterDataFacility.dateTo) : null

          if (from && to) {
            return apptDate >= from && apptDate <= to
          } else if (from) {
            return apptDate >= from
          } else if (to) {
            return apptDate <= to
          }
          return true
        })
      }

      // let facilityPatients = (patientData || []).filter(
      //     (patient) => patient.FacilityName === fac?.label
      // );
      let facilityPatients = Array.isArray(patientData) ? patientData.filter((patient) => patient.FacilityName === fac?.label) : []

      if (filterDataFacility.patientCreatedDate) {
        facilityPatients = facilityPatients.filter((patient) => new Date(patient.createdDate).toDateString() === new Date(filterDataFacility.patientCreatedDate).toDateString())
      }

      const totalFacilityPatients = facilityPatients.length

      const totalFacilityPatientList = facilityPatients

      const scheduledPatientIDs = new Set(facilityAppointments.map((appt) => appt.data.PatientID))

      const scheduledPatients = facilityPatients.filter((patient) => scheduledPatientIDs.has(patient.PatientID)).length

      const totalFollowUpPatients = facilityPatients.filter((patient) => patient.Status === 'Follow Up').length
      const totalFollowUpPatientsList = facilityPatients.filter((patient) => patient.Status === 'Follow Up')

      const totalNewPatients = facilityPatients.filter((patient) => patient.Status === 'NewPatient').length
      const totalNewPatientsList = facilityPatients.filter((patient) => patient.Status === 'NewPatient')

      const notScheduledPatients = facilityPatients.filter((patient) => !scheduledPatientIDs.has(patient.PatientID)).length
      const notScheduledPatientsList = facilityPatients.filter((patient) => !scheduledPatientIDs.has(patient.PatientID))

      const totalNotSeenPatientAppointments = facilityAppointments.filter((appt) => appt.data.patientSeen === false && appt.data.notSeenReason !== 'Discharged').length

      const notSeenPatientAppointmentsList = facilityAppointments.filter((appt) => appt.data.patientSeen === false && appt.data.notSeenReason !== 'Discharged')

      return {
        FacilityName: fac?.label,
        totalFacilityPatients,
        totalNotSeenPatientAppointments,
        totalFacilityPatientList,
        totalFollowUpPatients,
        scheduledPatients,
        totalNewPatients,
        notScheduledPatients,
        notScheduledPatientsList,
        totalNewPatientsList,
        totalFollowUpPatientsList,
        notSeenPatientAppointmentsList,
      }
    })

    setFacilityGroupedStats(mapFacilityStats)
    setIsPageLoading(false)
  }, [patientData, appointments, facilities, filterDataFacility])

  useEffect(() => {
    const today = new Date()

    const dayOfWeek = today.getDay()

    const firstDayOfWeek = new Date(today)
    firstDayOfWeek.setDate(today.getDate() - dayOfWeek + 1)

    const lastDayOfWeek = new Date(today)
    lastDayOfWeek.setDate(today.getDate() - dayOfWeek + 7)

    const formatDate = (date) => {
      const mm = String(date.getMonth() + 1).padStart(2, '0')
      const dd = String(date.getDate()).padStart(2, '0')
      const yyyy = date.getFullYear()
      return `${mm}/${dd}/${yyyy}`
    }

    setFilterDataFacility((prev) => ({
      ...prev,
      dateFrom: formatDate(firstDayOfWeek),
      dateTo: formatDate(lastDayOfWeek),
    }))
  }, [])

  const searchOptions = useMemo(
    () => ({
      width: '300px',
      // label: "Search",
      placeholder: 'Search Facility',
      value: filterDataFacility.search || '',
      type: 'text',
      onChange: (e) => {
        setFilterDataFacility((p) => ({
          ...p,
          search: e.target.value,
        }))
      },
    }),
    [filterDataFacility.search],
  )

  const selectDates = useMemo(
    () => [
      {
        label: 'Date from',
        value: filterDataFacility.dateFrom || '',
        onChange: (e) => {
          setFilterDataFacility((p) => ({
            ...p,
            dateFrom: e,
          }))
        },
        isMulti: false,
      },
      {
        label: 'Date to',
        value: filterDataFacility.dateTo || '',
        onChange: (e) => {
          setFilterDataFacility((p) => ({
            ...p,
            dateTo: e,
          }))
        },
        isMulti: false,
      },
    ],
    [filterDataFacility.dateFrom, filterDataFacility.dateTo],
  )

  const [showList, setShowList] = useState(false)
  const [selectedFacility, setSelectedFacility] = useState('')
  const [listFacility, setListFacility] = useState([])

  const [showNotSeenModal, setShowNotSeenModal] = useState(false)
  const [notSeenListArr, setNotSeenListArr] = useState([])

  const userData = JSON.parse(localStorage.getItem('user'))

  const role = userData?.Role
  return (
    <>
      <div
        style={{
          width: '100%',
          borderRadius: '10px',
          minHeight: '90vh',
          background: '#191919',
        }}
        className=" position-relative p-4"
      >
        <div className="py-4 gap-2 d-flex align-items-start justify-content-end">
          <div className="" style={{ width: 'max-content' }}>
            <CustomDatePickingFormat
              type="date"
              color="primary"
              value={filterData.date || ''}
              aria-describedby="exampleFormControlInputHelpInline"
              onChange={(e) => {
                setFilterData((p) => ({
                  ...p,
                  date: e, // Keep the date in "YYYY-MM-DD" format
                }))
              }}
            />
          </div>
          <div style={{ width: '300px' }}>
            <Select
              placeholder="Select Facility"
              name="facility"
              options={facilities}
              value={facilities.filter((fac) => filterData.facility.includes(fac?.label))}
              isMulti
              styles={{
                control: (base, state) => ({
                  ...base,
                  backgroundColor: '#191919',
                  borderColor: state.isFocused ? '#444' : '#444',
                  borderRadius: '6px',
                  boxShadow: 'none',
                  '&:hover': {
                    borderColor: '#444',
                  },
                }),
                menu: (base) => ({
                  ...base,
                  backgroundColor: '#000',
                  borderRadius: '6px',
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? '#191919' // blue for selected
                    : state.isFocused
                      ? '#2a2a2a'
                      : '#000',
                  color: 'white',
                  cursor: 'pointer',
                  padding: '12px 14px',
                  borderBottom: '1px solid #333',
                  ':last-of-type': {
                    borderBottom: 'none',
                  },
                  ':active': {
                    backgroundColor: '#2a2a2a',
                  },
                }),
                multiValue: (base) => ({
                  ...base,
                  backgroundColor: '#191919',
                  borderRadius: '4px',
                  border: '1px solid #454545ff',
                }),
                multiValueLabel: (base) => ({
                  ...base,
                  color: 'white',
                }),
                multiValueRemove: (base) => ({
                  ...base,
                  color: 'white',
                  ':hover': {
                    backgroundColor: '#333',
                    color: 'white',
                  },
                }),
                singleValue: (base) => ({
                  ...base,
                  color: 'white',
                }),
                placeholder: (base) => ({
                  ...base,
                  color: '#aaa',
                }),

                input: (base) => ({
                  ...base,
                  color: 'white',
                }),
                dropdownIndicator: (base) => ({
                  ...base,
                  color: 'white',
                  ':hover': { color: 'white' },
                }),
              }}
              isClearable
              onChange={(selectedOptions) =>
                setFilterData((prev) => ({
                  ...prev,
                  facility: selectedOptions ? selectedOptions.map((option) => option?.label) : [],
                }))
              }
              className="basic-multi-select"
              classNamePrefix="select"
            />
          </div>
          {/* <div style={{ width: "300px" }}>
                    <Select
                        placeholder="Select Provider"
                        name="facility"
                        options={providerOptions}
                        value={providerOptions.filter(option =>
                            filterData.providers.includes(option.label)
                        )}
                        isMulti
                        isClearable
                        onChange={(selectedOptions) =>
                            setFilterData((prev) => ({
                                ...prev,
                                providers: selectedOptions
                                    ? selectedOptions.map(option => option.label)
                                    : []
                            }))
                        }
                        className="basic-multi-select"
                        classNamePrefix="select"
                    />
                </div> */}
        </div>
        <div class="row ">
          <div
            onClick={() => {
              const data = {
                // facility: filterData.facility,
                // providers: [item?.name],
                scheduleDate: filterData.date,
              }
              localStorage.setItem('analyticsFilter', JSON.stringify(data))
              // window.open('/home/provider/appointment')
              window.location.replace('/home/provider/appointment')
            }}
            class="col-sm-3 mb-3 mb-sm-0"
          >
            <div
              style={{
                backgroundColor: '#1e1e1e',
                border: '1px solid #333',
                borderRadius: '10px',
                boxShadow: '0 0.5rem 1rem rgba(0, 0, 15, 0.5)',
                cursor: 'pointer',
                transition: 'background 0.2s ease',
              }}
              class="shadow card"
            >
              <div class="card-body">
                <p class="m-0 p-0" style={{ fontSize: '30px', fontWeight: 500, letterSpacing: '-1.5px' }}>
                  {statsValue?.totalAppointments}
                </p>
                <h5 class="card-title text-white">Total </h5>
              </div>
            </div>
          </div>
          <div
            onClick={() => {
              const data = {
                // facility: filterData.facility,
                // providers: [item?.name],
                scheduleDate: filterData.date,
              }
              localStorage.setItem('analyticsFilter', JSON.stringify(data))
              // window.open('/home/provider/appointment')
              window.location.replace('/home/provider/appointment')
            }}
            class="col-sm-3 mb-3 mb-sm-0"
          >
            <div
              style={{
                backgroundColor: '#1e1e1e',
                border: '1px solid #333',
                borderRadius: '10px',
                boxShadow: '0 0.5rem 1rem rgba(0, 0, 15, 0.5)',
                cursor: 'pointer',
                transition: 'background 0.2s ease',
              }}
              class="shadow card"
            >
              <div class="card-body">
                <p class="m-0 p-0" style={{ fontSize: '30px', fontWeight: 500, letterSpacing: '-1.5px' }}>
                  {statsValue?.totalSignedAppointments}
                </p>
                <h5 class="card-title text-white">Signed </h5>
              </div>
            </div>
          </div>
          <div
            onClick={() => {
              const data = {
                // facility: filterData.facility,
                // providers: [item?.name],
                scheduleDate: filterData.date,
              }
              localStorage.setItem('analyticsFilter', JSON.stringify(data))
              // window.open('/home/provider/appointment')
              window.location.replace('/home/provider/appointment')
            }}
            class="col-sm-3 mb-3 mb-sm-0"
          >
            <div
              style={{
                backgroundColor: '#1e1e1e',
                border: '1px solid #333',
                borderRadius: '10px',
                boxShadow: '0 0.5rem 1rem rgba(0, 0, 15, 0.5)',
                cursor: 'pointer',
                transition: 'background 0.2s ease',
              }}
              class="shadow card"
            >
              <div class="card-body">
                <p class="m-0 p-0" style={{ fontSize: '30px', fontWeight: 500, letterSpacing: '-1.5px' }}>
                  {statsValue?.totalNotSeenAppointments}
                </p>
                <h5 class="card-title text-white">Not Seen</h5>
              </div>
            </div>
          </div>
          <div
            onClick={() => {
              const data = {
                // facility: filterData.facility,
                // providers: [item?.name],
                scheduleDate: filterData.date,
              }
              localStorage.setItem('analyticsFilter', JSON.stringify(data))
              // window.open('/home/provider/appointment')
              window.location.replace('/home/provider/appointment')
            }}
            class="col-sm-3 mb-3 mb-sm-0"
          >
            <div
              style={{
                backgroundColor: '#1e1e1e',
                border: '1px solid #333',
                borderRadius: '10px',
                boxShadow: '0 0.5rem 1rem rgba(0, 0, 15, 0.5)',
                cursor: 'pointer',
                transition: 'background 0.2s ease',
              }}
              class="shadow card"
            >
              <div class="card-body">
                <p class="m-0 p-0" style={{ fontSize: '30px', fontWeight: 500, letterSpacing: '-1.5px' }}>
                  {statsValue?.totalNotSignedAppointments}
                </p>
                <h5 class="card-title text-white">Not Signed </h5>
              </div>
            </div>
          </div>
        </div>

        {/* <div class="row provider-card-info">
                {
                    allProviderGroupedStats.map((item, idx) => {
                        return (
                            <div class="col-sm-3 mb-3 mb-sm-0">
                                <div style={{ borderRadius: "10px", boxShadow: "0 0.5rem 1rem rgba(0, 0, 15, 0.01) !important;" }} class="shadow card">
                                    <div class="card-body">
                                        <p class="m" style={{ fontSize: "15px", marginBottom: "10px", fontWeight: 500, }}>{item?.name}</p>
                                        <div />
                                        <div className=''
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "repeat(2,1fr)",
                                                gap: "15px 10px"
                                            }}
                                        >
                                            <div className='d-flex flex-column stats-card-provider'>
                                                <span className='stats-card-provider-span'>{item?.totalAppointments}</span>
                                                <span className='stats-card-provider-second'>Total</span>
                                            </div>
                                            <div className='d-flex flex-column stats-card-provider'>
                                                <span className='stats-card-provider-span'>{item?.totalSignedAppointments}</span>
                                                <span className='stats-card-provider-second'>Signed</span>
                                            </div>
                                            <div className='d-flex flex-column stats-card-provider'>
                                                <span className='stats-card-provider-span'>{item?.notSeenAppointments}</span>
                                                <span className='stats-card-provider-second'>Not Seen</span>
                                            </div>
                                            <div className='d-flex flex-column stats-card-provider'>
                                                <span className='stats-card-provider-span'>{item?.totalNotSignedAppointments}</span>
                                                <span className='stats-card-provider-second'>Not Signed</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div> */}

        <Pageloader isLoading={isPageLoading} />

        {/* <Topper searchOptions={searchOptions} selectDates={selectDates} />
                <CTable>
                    <CTableHead>
                        <CTableRow>
                            <CTableHeaderCell scope="col">#</CTableHeaderCell>
                            <CTableHeaderCell scope="col">Facility</CTableHeaderCell>
                            <CTableHeaderCell scope="col">Total Patient</CTableHeaderCell>
                            <CTableHeaderCell scope="col">New Patient</CTableHeaderCell>
                            <CTableHeaderCell scope="col">Follow-up Patient</CTableHeaderCell>
                            <CTableHeaderCell scope="col">Missed</CTableHeaderCell>
                            <CTableHeaderCell scope="col">Not Scheduled Patient</CTableHeaderCell>
                        </CTableRow>
                    </CTableHead>
                    <CTableBody>
                        {
                            facilityGroupedStats.map((facility, index) => {
                                return (
                                    <CTableRow key={index}>
                                        <CTableHeaderCell scope="row">{index + 1}</CTableHeaderCell>
                                        <CTableDataCell
                                            onClick={() => {
                                                setShowList(true)
                                                setSelectedFacility(facility.FacilityName)
                                                setListFacility(facility.totalFacilityPatientList)
                                            }}
                                        >{facility.FacilityName}</CTableDataCell>
                                        <CTableDataCell
                                            onClick={() => {
                                                setShowList(true)
                                                setSelectedFacility(facility.FacilityName)
                                                setListFacility(facility.totalFacilityPatientList)
                                            }}
                                        >{facility.totalFacilityPatients}</CTableDataCell>
                                        <CTableDataCell
                                            onClick={() => {
                                                setShowList(true)
                                                setSelectedFacility(facility.FacilityName)
                                                setListFacility(facility.totalNewPatientsList)
                                            }}
                                        >{facility.totalNewPatients}</CTableDataCell>
                                        <CTableDataCell
                                            onClick={() => {
                                                setShowList(true)
                                                setSelectedFacility(facility.FacilityName)
                                                setListFacility(facility.totalFollowUpPatientsList)
                                            }}
                                        >{facility.totalFollowUpPatients}</CTableDataCell>
                                        <CTableDataCell
                                            onClick={() => {
                                                setShowNotSeenModal(true)
                                                setSelectedFacility(facility.FacilityName)
                                                const formattedPatients = facility?.notSeenPatientAppointmentsList.length > 0 && facility?.notSeenPatientAppointmentsList?.map((item, index) => ({
                                                    id: index + 1,
                                                    patientName: item?.Patient?.label || item?.data?.AppointmentName || "",   
                                                    startDate: item?.data?.StartTime?.split(" ")[0] ?? "",
                                                    notSeenReason: item?.data?.notSeenReason ?? "",
                                                    providerName: item?.data?.ProviderName ?? ""
                                                }));
                                                setNotSeenListArr(formattedPatients)
                                            }}
                                        >{facility.totalNotSeenPatientAppointments}</CTableDataCell>
                                        <CTableDataCell
                                            onClick={() => {
                                                setShowList(true)
                                                setSelectedFacility(facility.FacilityName)
                                                setListFacility(facility.notScheduledPatientsList)
                                            }}
                                        >{facility.notScheduledPatients}</CTableDataCell>
                                    </CTableRow>
                                )
                            })
                        }
                    </CTableBody>
                </CTable> */}
        <Pageloader isLoading={isPageLoading} />

        <CModal backdrop="static" scrollable visible={showList} size="lg" onClose={() => setShowList(false)} aria-labelledby="StaticBackdropExampleLabel">
          <CModalHeader>
            <CModalTitle id="StaticBackdropExampleLabel">{selectedFacility}</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <CTable>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell scope="col">#</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Name</CTableHeaderCell>
                  <CTableHeaderCell scope="col">DOB</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Age</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Patient Status</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {listFacility &&
                  listFacility.length > 0 &&
                  listFacility.map((item, index) => {
                    return (
                      <CTableRow key={index}>
                        <CTableHeaderCell scope="row">{index + 1}</CTableHeaderCell>
                        <CTableDataCell>
                          {item.FirstName} {item.LastName}
                        </CTableDataCell>
                        <CTableDataCell>{item.DOB}</CTableDataCell>
                        <CTableDataCell>{item.Age}</CTableDataCell>
                        <CTableDataCell>{item?.Status === 'NewPatient' ? 'New Patient' : item?.Status}</CTableDataCell>
                      </CTableRow>
                    )
                  })}
              </CTableBody>
            </CTable>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" variant="outline" onClick={() => setShowList(false)}>
              Close
            </CButton>
          </CModalFooter>
        </CModal>
      </div>

      <CModal backdrop="static" scrollable visible={showNotSeenModal} size="lg" onClose={() => setShowNotSeenModal(false)} aria-labelledby="StaticBackdropExampleLabel1">
        <CModalHeader>
          <CModalTitle id="StaticBackdropExampleLabel1">{selectedFacility && showNotSeenModal ? selectedFacility : ''}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CTable>
            <CTableHead>
              <CTableRow>
                <CTableHeaderCell scope="col">#</CTableHeaderCell>
                <CTableHeaderCell scope="col">Name</CTableHeaderCell>
                <CTableHeaderCell scope="col">Schedule Date</CTableHeaderCell>
                <CTableHeaderCell scope="col">Reason</CTableHeaderCell>
                <CTableHeaderCell scope="col">Provider</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {showNotSeenModal &&
                notSeenListArr &&
                notSeenListArr.length > 0 &&
                notSeenListArr.map((p, index) => {
                  return (
                    <CTableRow key={p.id}>
                      <CTableHeaderCell scope="row">{p.id}</CTableHeaderCell>
                      <CTableDataCell>{p.patientName}</CTableDataCell>
                      <CTableDataCell>{p.startDate}</CTableDataCell>
                      <CTableDataCell>{p.notSeenReason}</CTableDataCell>
                      <CTableDataCell>{p.providerName}</CTableDataCell>
                    </CTableRow>
                  )
                })}
            </CTableBody>
          </CTable>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" variant="outline" onClick={() => setShowNotSeenModal(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ProviderAnalytics
